import { Outlet } from '@tanstack/react-router';

import { useBranchFeatures } from '@/api/use-branch-features';
import Loading from '@/components/loading';
import Background20HzAudio from '@/features/background-20hz-audio';
import { useLogin } from '@/features/desktop-app/hooks/useLogin';
import Navbar from '@/features/navbar';
import Status from '@/features/status';
import { useExtensionSSE } from '@/hooks/use-extension-sse';
import { usePauseOnMissedCallSSE } from '@/hooks/use-pause-on-missed-call-sse';
import { useScreenPopToCaseSSE } from '@/hooks/use-screen-pop-to-case-sse';

export default function DesktopApp() {
  const featuresQuery = useBranchFeatures();
  const { isLoggedOnQueue } = useLogin();
  useExtensionSSE();
  useScreenPopToCaseSSE();
  usePauseOnMissedCallSSE();

  if (featuresQuery.isError || !featuresQuery.data) return <Loading />;
  if (featuresQuery.data.queueMetrics && !isLoggedOnQueue) return <Loading />;

  return (
    <>
      {featuresQuery.data.queueMetrics && <Status />}
      <Background20HzAudio />
      <div className="flex grow overflow-hidden bg-[#fafafa]">
        <Outlet />
      </div>
      <Navbar />
    </>
  );
}
